import { useDispatch, useSelector } from 'react-redux';

import {
  resetFilters,
  setFilter,
  setNamedFilters,
  setOrderBy,
  setPagination
} from '@common/slices';
import { IFilterModel, IOrderBy, IPagination } from '@common/types';
import { RootState } from '@core/redux/store';
import { IAbstractRecord } from '@models';

export const useListFilters = (page: string) => {
  const dispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.filterState[page]);

  const updateFilters = (data: IFilterModel) => {
    // Check if filters (namedFilters or searchKey) have changed
    const currentFilters = filters;
    const filtersChanged =
      JSON.stringify(currentFilters?.namedFilters) !==
        JSON.stringify(data.namedFilters) ||
      currentFilters?.searchKey !== data.searchKey;

    // If filters changed, reset pageNumber to 1
    const updatedData = filtersChanged
      ? { ...data, pagination: { ...data.pagination, pageNumber: 1 } }
      : data;

    dispatch(setFilter({ page, filter: updatedData }));
  };

  return {
    filters,
    updateFilters,
    setNamedFilters: (data: IAbstractRecord) =>
      dispatch(setNamedFilters({ page, namedFilters: data })),
    setPagination: (pageData: IPagination) =>
      dispatch(setPagination({ page, pagination: pageData })),
    setOrderBy: (orderData: IOrderBy) =>
      dispatch(setOrderBy({ page, ...orderData })),
    reset: () => dispatch(resetFilters({ page }))
  };
};
